<!--<ng-container *ngIf="show">-->
<!--    <mat-progress-bar-->
<!--        [mode]="mode"-->
<!--        [value]="progress"></mat-progress-bar>-->
<!--</ng-container>-->

<!-- <ngx-spinner ></ngx-spinner> -->
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<!-- <ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  [fullScreen]="true"
>
  <img
    src="assets/gifs/SR_Page_Loader.gif"
    alt="Loading"
    style="width: 120px;"
  />
  <p style="color: white; margin-top: 10px;display:flex;justify-content: center;">Loading...</p>
</ngx-spinner> -->
